// Module
var code = `<div appHeaderBar>
    <header-bar-title>Bank Account Details</header-bar-title>
</div>

<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <div class="HOA-container" *ngIf="doneLoading">
        <div class="HOA-container__header">
            <h1 class="HOA-container__header-text"
                tid="accountNickname" >
                <span>{{paymentMethod.nickname}}</span>
                <span>({{paymentMethod.maskedId}})</span>
            </h1>
        </div>
        <div class="HOA-container__content">
            <div class="HOA-flextable-component__subheader u-mT3 u-mB7"
                 tid="secondaryHeader">
                Bank Account Details
                <button type="button"
                        id="secondaryEdit"
                        tid="secondaryEdit"
                        class="Button Button--link"
                        [routerLink]="['/wallet/editcheckdetails', paymentMethod.id]"
                        [state]="{paymentMethodId: paymentMethod.id}">
                    Edit
                </button>
            </div>
            <div class="HOA-flextable-component HOA-flextable-component__form HOA-Has-Default-Switch">
                <div class="Field HOA-flextable-component__cell-input HOA-sm-order-2 HOA-lg-order-1">
                    <label class="Field-label" tid="routingNumberLabel">Routing Number</label>
                    <div class="u-pH4">
                        <span tid="routingNumber">{{paymentMethod.routingNumber}}</span> -
                        <span>{{paymentMethod.bankName}}</span>
                    </div>
                </div>
                <div *ngIf="paymentMethod.defaultMethod" class="Field u-pH4 HOA-sm-order-1 HOA-lg-order-2">
                    <div class="HOA-Toggle-Align HOA-flex-component">
                                <span class="Icon Icon--18 u-iconBlue"
                                      tid="checkingDefaultRadioButton">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                         width="18"
                                         height="18"
                                         viewBox="0 0 72 72">
                                        <title>Default Payment</title>
                                        <path class="stroke_layer fill_layer"
                                              fill="#082538"
                                              stroke="#082538"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                              stroke-width="4.6"
                                              d="M36.3 9l6.3 20.6h20.7L46.6 42.4 52.9 63 36.3 50.3 19.6 63l6.3-20.6L9.3 29.6h20.6L36.3 9z">
                                        </path>
                                    </svg>
                                </span>
                        <span class="u-pL2 Toggle-label">Default Payment</span>
                    </div>
                </div>
            </div>
            <div class="HOA-flextable-component HOA-flextable-component__form">
                <div class="Field HOA-flextable-component__cell-input">
                    <label class="Field-label" tid="accountNumberLabel">Account Number</label>
                    <div class="u-pH4">
                        <span tid="accountNumber">xxxx{{paymentMethod.maskedId}}</span>
                    </div>
                </div>
                <div class="HOA-flextable-component__cell--50">
                </div>
            </div>
            <div class="HOA-container__content-hrule
                                HOA-propertyblock-flextable__cell
                                HOA-propertyblock-flextable__cell--100 u-mT5">
            </div>
            <div class="HOA-flextable-component__subheader u-mT3 u-mB7" tid="schedulePaymentHeader">
                Scheduled Payments
            </div>
            <app-payment-schedule *ngIf="true"
                                  [paymentSchedules]="paymentSchedules"
                                  [isPaymentMethodView]="true">
            </app-payment-schedule>

            <div class="u-pT4 HOA-flex-component HOA-flextable-component__flex-end">
                <button name="cancel"
                        id="back"
                        tid="back"
                        type="button"
                        class="Button Button--link "
                        (click)="cancel()">
                    Back
                </button>
            </div>
        </div>
    </div>

    <div class="HOA-remove-button-container" *ngIf="doneLoading">
        <button name="submitDelete"
                id="submitDelete"
                tid="submitDelete"
                type="submit"
                class="Button Button--outline"
                (click)="removeCheck()">
            Delete Payment Method
        </button>
    </div>
</app-page-content>`;
// Exports
module.exports = code;